module.exports = __webpack_public_path__ + "img/21_65.45b18170.png";